/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Yelp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Yelp"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M10.447 16.198c.268-.316.627-.387 1.013-.234.362.144.528.394.53.82q.004 1.104.002 2.206h-.025c0 .735.006 1.47-.002 2.204-.006.557-.292.854-.845.8a7.2 7.2 0 0 1-3.391-1.241c-.463-.318-.5-.726-.142-1.157q1.42-1.707 2.86-3.398m3.429-.92c.233-.278.535-.383.884-.268q2.15.714 4.297 1.435c.327.11.513.323.533.693-.067.195-.112.4-.204.582a8.1 8.1 0 0 1-1.911 2.442c-.122.107-.263.2-.41.27-.344.164-.664.096-.864-.223a320 320 0 0 1-2.465-3.96c-.208-.34-.102-.68.14-.971M4.57 12.032c.16-.705.55-.88 1.22-.613q1.98.796 3.953 1.606c.416.17.6.465.582.894-.018.407-.22.664-.652.802-1.387.442-2.773.886-4.164 1.316-.553.17-.902-.018-1.025-.59-.145-1.153-.057-2.778.087-3.415M16.204 8.31c.376-.504.784-.553 1.249-.122a7.4 7.4 0 0 1 1.92 2.867c.222.597.025.946-.59 1.104-1.4.36-2.803.705-4.205 1.053-.084.021-.172.026-.242.036-.38-.011-.64-.192-.807-.502a.785.785 0 0 1 .062-.895c.871-1.18 1.736-2.366 2.613-3.542M10.6 2.004c.682-.04.922.189.969.863.167 2.404.326 4.81.494 7.302-.024.209-.023.511-.1.791-.17.613-.78.793-1.262.374a2.8 2.8 0 0 1-.5-.602 2024 2024 0 0 1-3.993-6.305c-.383-.607-.306-.973.337-1.3a10.25 10.25 0 0 1 4.056-1.123"
      className="SVG"
    />
  </svg>
);

export const YelpIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'yelp-icon'}
      icon={Yelp}
      {...props}
      size={size}
    />
  );
};
